import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomUpdateAiMappingDetectionMutation } from "generated/graphql";

export const useUpdateAiMappingDetection = () => {
  const [mutation, { data, loading, error }] = useCustomUpdateAiMappingDetectionMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "updateAiMappingDetection" },
    { hideMessage: true }
  );
};
